export function buildBooleanFilter<Keys extends string>(
  filters: Array<[key: Keys, value: string | undefined]>,
): Partial<Record<Keys, { _eq: string }>> {
  return Object.fromEntries(
    filters
      .map(([key, value]) =>
        value === undefined ? undefined : [key, { _eq: value }],
      )
      .filter(Boolean) as Array<[string, { _eq: string }]>,
  ) as Partial<Record<Keys, { _eq: string }>>;
}
